<script setup lang="ts">
const props = defineProps({
  component: {
    type: String,
    default: "",
  },
});
</script>
<template>
  <div>
    <h1>Error Loading Component</h1>
    <p>Component: {{ props.component }}</p>
  </div>
</template>
